import AppFooter from '@/components/novartis/AppFooter.vue';
import AppHeader from '@/components/novartis/AppHeader.vue';
import BtnTop from '@/components/novartis/BtnTop.vue';
import CookieDisclaimer from '@/components/novartis/CookieDisclaimer.vue';
import InnerContent from '@/components/novartis/InnerContent.vue';
import LegalDisclaimer from '@/components/novartis/LegalDisclaimer.vue';
import Preloader from '@/components/novartis/Preloader.vue';

const NovartisPlugin = {
  install(Vue) {
    Vue.component(AppFooter.name, AppFooter);
    Vue.component(AppHeader.name, AppHeader);
    Vue.component(BtnTop.name, BtnTop);
    Vue.component(CookieDisclaimer.name, CookieDisclaimer);
    Vue.component(InnerContent.name, InnerContent);
    Vue.component(LegalDisclaimer.name, LegalDisclaimer);
    Vue.component(Preloader.name, Preloader);
  },
};

export default NovartisPlugin;
